<template lang="pug">
  el-main(style="text-align: center; margin: auto;")
    el-row
      el-col(:span="24" 
        style="margin-bottom:2%;")  
        img(src="../assets/settingup.png") 

    el-row
      el-col(:span="24")
        small#info A Canvas LTI Application by MathSmith. 2019        

    el-row
      el-col(:span="24")
        h3#info(
          class='error-standard'
        ) {{ msg }}
  </template>

<script>
  import utilMixin from '@/components/mixins/utilMixin'

  export default {
    name: 'ErrorPage',
    mixins: [utilMixin],

    props: {
      msg: {
        type: String,
        required: true,
     },
    },

    created() {
      this.mThirdPartyCookiesEnabled()
    },
  } 
</script>

<style module>
  .error-standard {
    width: parent;
    margin-top:10px;
    color: #909399;
    font-size: 20px;
  }


</style>
